module.exports = __webpack_public_path__ + "img/20220312_144854.0690cac0.jpg";